export default "__VITE_ASSET__BE$qGdSw__"